// A one-line notice that an approval on this engagement was rejected (QA #23/#24). Built from the
// approvals list every viewer of the engagement receives, so the Sales Agent sees it too.
import type { ApprovalRequestOut } from '@/redux/internal-services/workflowEngineApi';

const label = (code: string) => {
  const words = code.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export function rejectionNotice(approvals: ApprovalRequestOut[]): string | null {
  const rejected = approvals.find((a) => a.status === 'rejected');
  if (!rejected) return null;
  const reason = rejected.decision_comments?.trim();
  return `${label(rejected.approval_type)} was rejected${reason ? `: ${reason}` : ''}. Revise the proposal and resubmit it for approval.`;
}
